import {NgOptimizedImage} from "@angular/common";
import {Component} from "@angular/core";

@Component({
  selector: "app-large-logo-shear",
  templateUrl: "./large-logo-shear.html",
  imports: [
    NgOptimizedImage,
  ],
})
export class LargeLogoShear {
}
